import { Table } from "reactstrap";
import { Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";

const InvoiceHeader = () => {
  return (
    <td className="p-0">
      <Table className="logo-wrappper" style={{ width: "100%" }} borderless>
        <tbody>
          <tr>
            <td className="p-0">
              <Image src={dynamicImage(`logo/logo.png`)} alt="logo" />
              <span style={{ opacity: "0.8", display: "block", marginTop: 10 }}>202-555-0258</span>
            </td>
            <td className="address p-0" style={{ textAlign: "right", opacity: "0.8", width: "16%" }}>
              <span>1982 Harvest Lane New York, NY12210 United State</span>
            </td>
          </tr>
        </tbody>
      </Table>
    </td>
  );
};

export default InvoiceHeader;
